import React, {useRef, useEffect, useState} from "react";
// リダイレクト(認証期間切れの場合にリダイレクトするため)
import {useHistory} from "react-router-dom";

import IconButton from "@material-ui/core/IconButton";
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Fade from '@material-ui/core/Fade';

import {Link} from "react-router-dom";
import ListItemText from "@material-ui/core/ListItemText";
import Tooltip from '@material-ui/core/Tooltip';

import {
  apollo_user_download_path,
} from "../../atom/Apollo_links";

import {apollo_useStyles} from "../../atom/Apollo_styles";
import {ApolloContext} from "../../atom/Apollo_Context";
import {ApolloMessage} from "../../atom/Apollo_Mesasge";
import {ApolloAxios} from "../../atom/Apollo_ApiRequest3";
import {ApolloLinkDialog} from "../../molecule/Apollo_LinkDialog";
// メッセージ定義
import {
  GetMessage,
  UI_MANUAL_DOWNLOAD,
} from "../../atom/Apollo_MesasgeDefinition";
// 認証期間切れの処理
import {ApolloExpired} from "../../atom/Apollo_Expired";
import { Buffer } from 'buffer';

export const ManualMenu = () => {
  const classes = apollo_useStyles();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  // リダイレクト(認証期間切れの場合にリダイレクトするため)
  const history = useHistory();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSubmenuVisible(true);
  };

  const bucket = useRef("");
  const num = useRef(0);
  const files = useRef<string[]>([]);
  const filePaths = useRef<string[][]>([]);
  const {data, setmsg} = React.useContext(ApolloMessage);
  const [download, setDownload] = useState(0);
  const [disabled, setDisabled] = useState<boolean[]>([false,false,false]);
  const [submenuVisible, setSubmenuVisible] = useState(true);

  const initProc = () => {
    // バケット名
    bucket.current = process.env.REACT_APP_DOCUMENT_MANAGEMENT_MANUAL_BUCKET ? process.env.REACT_APP_DOCUMENT_MANAGEMENT_MANUAL_BUCKET : "";
    // ファイルパス
    files.current = [
      process.env.REACT_APP_DOCUMENT_MANAGEMENT_MANUAL_FILE_2 ? process.env.REACT_APP_DOCUMENT_MANAGEMENT_MANUAL_FILE_2 : "",
      process.env.REACT_APP_DOCUMENT_MANAGEMENT_MANUAL_FILE_3 ? process.env.REACT_APP_DOCUMENT_MANAGEMENT_MANUAL_FILE_3 : "",
      process.env.REACT_APP_DOCUMENT_MANAGEMENT_MANUAL_FILE_4 ? process.env.REACT_APP_DOCUMENT_MANAGEMENT_MANUAL_FILE_4 : "",
    ]
    var bucketWork = bucket.current;
    var fileWork = files.current;
    var disabledWork:boolean[] = [];
    for (var idx in fileWork) {
      if (!fileWork[idx]) {
        // ダウンロードファイル未定義
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: GetMessage("0",UI_MANUAL_DOWNLOAD,"E","2"),
          }
        });
        // ダウンロード出来ないようにする
        disabledWork.push(true);
      } else {
        files.current[idx] = fileWork[idx];
        if (fileWork[idx]) {
          filePaths.current[idx] = fileWork[idx].split('/');
        }
        // ダウンロード出来るようにする
        disabledWork.push(false);
      }
    }
    if (!bucketWork) {
        // ダウンロードバケット未定義
        setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: GetMessage("0",UI_MANUAL_DOWNLOAD,"E","1"),
        }
      });
      // ダウンロード出来ないようにする
      for (var idx in fileWork) {
        disabledWork[idx] = true;
      }
    } else {
      bucket.current = bucketWork;
    }
    setDisabled(disabledWork);
  };
  
  // 取得データを返却する
  const dataToBlob = (data: any): Blob => {
    // BASE64でコード
    let buf = Buffer.from(data, 'base64');
    const blob = new Blob([buf], {
        type: 'text/csv'
    })
    return blob
  }

  // APIでS3ファイルを取得する
  useEffect(() => {
    if (download === 0) return; 
    setmsg({
      type: "loading",
      payload: {
        ...data,
        loading: true,
      }
    });
    // スラッシュを@@に置換する
    var fileWork = filePaths.current[num.current].join('@@');
    const url = apollo_user_download_path + bucket.current + "/" + fileWork;
    ApolloAxios.get(url).then(response => {
      if (response.data.resultCode === 0) {
        setmsg({
          type: "loading",
          payload: {
            ...data,
            loading: false,
          }
        });
        createFile(response.data.result);
      } else {
        console.log(response.data.message);
        setmsg({
          type: "all",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: GetMessage("0",UI_MANUAL_DOWNLOAD,"E","0"),
            loading: false
          }
        });
      }
    }).catch(err => {
      // 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, GetMessage("0",UI_MANUAL_DOWNLOAD,"E","0"), data, setmsg, history)) {
        // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
      }
    });
  }, [download]);

  // ダウンロードハンドラ
  const handleDownload = (idx: number) => {
    initProc();
    num.current = idx;
    setDownload(download+1);
    return undefined;
  }

  // APIから受信データをファイルに書き出す
  const createFile = (data:any) => {
    const blob = dataToBlob(data)
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = filePaths.current[num.current][filePaths.current[num.current].length - 1];
    link.click();
  }

  //---ＦＡＱサイト-選択-開始
  const {state} = React.useContext(ApolloContext)
  const managementManualUrl = useRef("");
  const faqUrl = useRef("");
  // 管理マニュアルサイトリンク
	managementManualUrl.current = process.env.REACT_APP_MANAGEMENT_MANUAL ? process.env.REACT_APP_MANAGEMENT_MANUAL: "";
	// ＦＡＱサイトリンク
	faqUrl.current = process.env.REACT_APP_FAQ ? process.env.REACT_APP_FAQ: "";
	// 管理マニュアルサイトリンクハンドラ
	const managementManualSite = () => {
		window.open(managementManualUrl.current);
	}
  
  const handleMouseOver = () => {
    setSubmenuVisible(false); // サブメニューを表示
  };

  const handleOtherMouseOver = () => {
    setSubmenuVisible(true); // サブメニューを非表示
  };
	// ＦＡＱサイトリンクハンドラ
	const faqSite = () => {
		window.open(faqUrl.current);
	}
  //---ＦＡＱサイト-選択-終了

  return (
    <div>
      <Tooltip title="
      FAQ・マニュアル" placement="bottom">
        <IconButton
          aria-label="more"
          aria-controls="system-menu"
          aria-haspopup="true"
          color="inherit"
          onClick={handleClick}
        >
          <img src={"/icon/header_04.png"} alt="setting" height="auto" width="25"/>
        </IconButton>
      </Tooltip>
      <Menu
        id="fade-menu"
        anchorEl={anchorEl}
        color="primary"
        keepMounted
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
      >

        <div
          onMouseOver={handleOtherMouseOver} 
        >
          <Link to={"#"} onClick={managementManualSite} className={classes.link}>
            <MenuItem onClick={handleClose}>
              <ListItemText primary="管理画面マニュアル／運用ガイド"/>
            </MenuItem>
          </Link>

          <ApolloLinkDialog
            handleLink={handleDownload}
            title={"一括アップロード仕様書"}
            modaltext={"一括アップロード仕様書"}
            text={"ダウンロード"}
            disabled={disabled[0]}
            num={0}
            close={handleClose}
          />
        </div>

        <div
          onMouseOver={handleMouseOver}
        >
          <MenuItem className={classes.link}>
            <ListItemText primary="セールスシート"/>
          </MenuItem>
        </div>

        <ApolloLinkDialog
          handleLink={handleDownload}
          title={"　∟ docomo Ad Network"}
          modaltext={"docomo Ad Network"}
          text={"ダウンロード"}
          disabled={disabled[1]}
          num={1}
          close={handleClose}
          readonly={submenuVisible}
        />
        <ApolloLinkDialog
          handleLink={handleDownload}
          title={"　∟ メール広告：メッセージSポイントプラス"}
          modaltext={"メール広告：メッセージSポイントプラス"}
          text={"ダウンロード"}
          disabled={disabled[2]}
          num={2}
          close={handleClose}
          readonly={submenuVisible}
        />
    
        <Link to={"#"} onClick={faqSite} className={classes.link}>
          <MenuItem onClick={handleClose}>
            <ListItemText primary="ＦＡＱサイト"/>
          </MenuItem>
        </Link>

      </Menu>
    </div>
  );
}
